/**
 * Model for account administration
 */

define([
  "backbone",
  "messaging/messenger",
  "configuration/properties",
  "modules/shared/adminMenu/adminMenuModel",
], function (Backbone, Messenger, Properties, AdminMenuModel) {
  Messenger.reqres.setHandler("account:admin:menu:items", function () {
    var isGlobalAdmin = Messenger.reqres.request("user:is:global:admin");

    // TODO: Determine if the user is a landlord admin
    var isLandlordAdmin = false;
    var isTenantAdmin = Messenger.reqres.request("user:is:admin");

    var menuItems = new AdminMenuModel.menuItems([]);

    menuItems.add({
      name: "authoring",
      className: "accountAdminItem",
      label: "admin.accountAdmin.back",
    });

    menuItems.add({
      name: "divider",
      className: "divider",
      label: "",
    });

    if (isGlobalAdmin) {
      menuItems.add({
        name: "engines",
        className: "accountAdminItem",
        label: "admin.accountAdmin.engines",
      });
    }
    if (isGlobalAdmin || isLandlordAdmin) {
      if (Properties.showLandlords) {
        // Landlord admins will have view-only
        menuItems.add({
          name: "landlords",
          className: "accountAdminItem",
          label: "admin.accountAdmin.landlords",
        });
      }
    }
    if (isGlobalAdmin || isLandlordAdmin || isTenantAdmin) {
      menuItems.add({
        name: "tenants",
        className: "accountAdminItem",
        label: "admin.accountAdmin.tenants",
      });
      menuItems.add({
        name: "kbs",
        className: "accountAdminItem",
        label: "admin.accountAdmin.kbs",
      });
    }

    return menuItems;
  });

  Messenger.reqres.setHandler("account:admin:menu:style", function () {
    return new AdminMenuModel.menuType({ type: "pills", stacked: true });
  });
});
